export const downloadJson = (jsonData, downloadedJsonFileName) => {
  const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
    JSON.stringify(jsonData)
  )}`;
  const link = document.createElement("a");
  link.href = jsonString;
  link.download = `${downloadedJsonFileName}.json`;
  link.click();
};
